<template>
  <div class="error-main layout">
    <div class="back flex flex-space-between flex-align-center mx-auto">
      <nuxt-img
        :src="'/img/basic-icon/back.svg'"
        width="28"
        height="28"
        alt="back"
        @click="navigateTo('/')"
      />
    </div>
    <div class="emotion-group abs-middle flex flex-column flex-align-center">
      <nuxt-img
        class="emotion"
        :src="'/img/emotion-icon/sweat-grinning.webp'"
        preload
        format="webp"
        alt="emotion"
      />
      <div class="text-group flex flex-column flex-align-center">
        <p class="success-title mb-default">
          {{ $t('error.title') }}
        </p>
        <p
          v-for="(text, index) in $tm('error.subtitle')"
          :key="index"
          class="success-description"
        >
          {{ $rt(text) }}
        </p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const { t } = useLocale()
const props = defineProps({
  error: Object as () => NuxtError
})
console.log('Error:', props.error)
useHead({
  title: '유심사'
})

</script>
